exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".datetime[data-v-5c563f96]{display:flex;align-items:center}.date[data-v-5c563f96]{width:124px}.time[data-v-5c563f96]{margin:0 16px;width:76px}", ""]);

